import React from 'react';
import { BsFillInfoCircleFill } from 'react-icons/bs';
import airkorea from "../../images/airkorea.png";

function Forecast(props) {
    return (
        <div className='forecast' >
            <div className="title">
                <h2>대기오염 예보</h2>
            </div>

            <div className='span'>
                <BsFillInfoCircleFill />
                <span> 예보는 05시, 11시, 17시, 23시 기준으로 국립환경과학원 발표자료입니다.<br />
                    ※ 오존 예보 운영기간 : 매년 4월 15일~10월 15일
                </span><br />
                <BsFillInfoCircleFill /> <span> 기준 일시 :  </span>
            </div>
            <div className='foreTable'>
                <div className='tableBox'>
                    <table>
                        <thead>
                            <tr style={{ borderBottom: '2px solid #ddd' }}>
                                <th>구분</th>
                                <th>어제()</th>
                                <th>오늘()</th>
                                <th>내일()</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr >
                                <th>초미세먼지</th>
                                <td >
                                    <img src='' /><br />

                                </td>
                                <td>
                                    <img src='' /><br />

                                </td>
                                <td>
                                    <img src='' /><br />

                                </td>
                            </tr>
                            <tr>
                                <th>미세먼지</th>
                                <td>
                                    <img src='' /><br />

                                </td>
                                <td>
                                    <img src='' /><br />

                                </td>
                                <td>
                                    <img src='' /><br />

                                </td>
                            </tr>
                            <tr>
                                <th>오존</th>
                                <td>
                                    <img src='' /><br />

                                </td>
                                <td>
                                    <img src='' /><br />

                                </td>
                                <td>
                                    <img src='' /><br />

                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div className='predict'>
                    <div className='h3'>
                        <h3>대기오염 농도 예측 모델</h3>
                    </div>

                    <div className='predictTable'>
                        <table>
                            <thead>
                                <tr>
                                    <th>초미세먼지</th>
                                    <th>미세먼지</th>
                                    <th>오존</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td data-label='초미세먼지' className='img'><img src='' alt="Slideshow" /></td>
                                    <td data-label='미세먼지' className='img'>
                                        <img src='' alt="Slideshow" />
                                    </td>
                                    <td data-label='오존' className='img'>
                                        <img src='' alt="Slideshow" />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className='iframeContainer'>

                    <div className='iframeInner' >
                        <div className='iframeInnerAir' >
                            <h3>에어코리아</h3>

                            <div className='iframeDiv'>
                                <a href="https://www.airkorea.or.kr/web/" target='_blank'>
                                    <img src={airkorea} alt="" /></a>
                                <div className='airIframe'>
                                </div>

                            </div>
                        </div>
                        <div className='iframeInnerAir'>
                            <h3>경기도 대기환경정보</h3>
                            <div className='iframeDiv'  >
                                <div className='airIframe' >
                                    <iframe src="https://air.gg.go.kr/" scrolling='no' ></iframe>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div >
    );
}

export default Forecast;